import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  ReferenceInput,
  SelectInput,
  FunctionField,
} from 'react-admin';

const sessionFilters = [
  <TextInput key="q" source="q" label="Search" alwaysOn resettable />,
  <ReferenceInput
    key="programId"
    source="programId"
    reference="programs"
    perPage={100}
    sort={{ field: 'name', order: 'ASC' }}
    alwaysOn
  >
    <SelectInput optionText="name" label="Program" emptyText="— All —" />
  </ReferenceInput>,
];

const ListSessions = (props) => (
  <List
    {...props}
    exporter={false}
    filters={sessionFilters}
    sort={{ field: 'name', order: 'ASC' }}
    perPage={25}
  >
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="id" label="ID" />
      <TextField source="name" label="Session Name" />
      <FunctionField label="Program" render={(record) => record?.program?.name || '—'} />
    </Datagrid>
  </List>
);

export default ListSessions;
